import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import api from "../../api/axiosInstance";
import Logo from "../../assets/logosnake.jpg";
import "./VerifyEmail.css";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const location = useLocation();

  const email = location.state?.email;
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await api.post("/api/admin/login", {
        email,
        code: otp.toString(),
      });

      localStorage.setItem("adminToken", res.data.token);
      localStorage.setItem("adminData", JSON.stringify(res.data.admin));
      localStorage.setItem("adminRole", res.data.admin.role);

      toast.success("OTP verified successfully");

      // navigate("/Layout/Dashboard");
      navigate("/Layout/Users");
    } catch (err) {
      console.error(err.response?.data);
      toast.error(err.response?.data?.message || "Invalid OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="right-panel">
        <form className="login-card" onSubmit={handleSubmit}>
          <img className="logo" src={Logo} alt="logo" />
          <h2>Verify Email</h2>

          <p className="center">
            Enter the 6-digit OTP sent to <br />
            <strong>
              {email
                ? email.replace(/(.{2}).+(@.+)/, "$1****$2")
                : "your email"}
            </strong>
          </p>

          <div className="otp-container">
            <input
              type="text"
              className="otp-input"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
          </div>

          <button className="submit-btn" type="submit" disabled={loading}>
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
        </form>
      </div>
    </div>
  );
}
